// extracted by mini-css-extract-plugin
export var active = "_ao-d";
export var blink = "_ao-e";
export var container = "_ao-5";
export var controls = "_ao-0";
export var controlsRight = "_ao-1";
export var fakeCursor = "_ao-c";
export var hidden = "_ao-b";
export var quillContainerSmall = "_ao-7";
export var quillEditor = "_ao-6";
export var quillEditorSmall = "_ao-8";
export var quillFormatButtons = "_ao-a";
export var quillToolbar = "_ao-9";
export var removePadding = "_ao-2";
export var state = "_ao-3";
export var stateTitle = "_ao-4";